import React, { FunctionComponent } from 'react';

import Image from 'next/image';
import classNames from 'classnames';

import Row from '@/components/layout/Row';
import Col from '@/components/layout/Col';
import Header from '@/components/typography/Header';

import { IPrismicContentElement } from '@/pageGeneration/services/prismicApi/types';
import PrismicRichText from '@/components/design/PrismicRichText';
import styles from './SafetyPageComponent.module.scss';

interface IProps {
  contentTop: IPrismicContentElement[];
  contentMiddle: IPrismicContentElement[];
  contentBottom: IPrismicContentElement[];
}

const SafetyPageComponent: FunctionComponent<IProps> = ({ contentTop, contentMiddle, contentBottom }) => {
  const topSection = contentTop[0];
  const leftCard = contentMiddle[0];
  const centerCard = contentMiddle[1];
  const rightCard = contentMiddle[2];
  const bottomSection = contentBottom[0];
  return (
    <>
      <Row gutter={[30, 0]} className={styles.section}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className={styles.bodyImageContainer}>
            <Image
              alt=" "
              src={topSection.image.url}
              fill
              sizes="100vw"
              style={{
                objectFit: 'cover',
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <div className={styles.bodyContentContainer}>
            <PrismicRichText items={topSection.text} />
          </div>
        </Col>
      </Row>
      <Row gutter={[30, 0]} className={classNames('is-flex', styles.section)}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <div className={styles.imageCardContainer}>
            <div className={styles.imageCard}>
              <Image
                alt=""
                src={leftCard.image.url}
                fill
                sizes="100vw"
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className={styles.cardBody}>
              <Header level={5} color="primary" strong marginBottom={0}>
                {leftCard.title}
              </Header>
              <PrismicRichText items={leftCard.text} />
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <div className={styles.imageCardContainer}>
            <div className={styles.imageCard}>
              <Image
                alt=""
                src={centerCard.image.url}
                fill
                sizes="100vw"
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className={styles.cardBody}>
              <Header level={5} color="primary" strong marginBottom={0}>
                {centerCard.title}
              </Header>
              <PrismicRichText items={centerCard.text} />
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <div className={styles.imageCardContainer}>
            <div className={styles.imageCard}>
              <Image
                alt=" "
                src={rightCard.image.url}
                fill
                sizes="100vw"
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className={styles.cardBody}>
              <Header level={5} color="primary" strong marginBottom={0}>
                {rightCard.title}
              </Header>
              <PrismicRichText items={rightCard.text} />
            </div>
          </div>
        </Col>
      </Row>
      <Row gutter={[0, 0]} className={classNames('is-flex', styles.section)}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <div className={styles.panelSegmentImage}>
            <Image
              alt=""
              src={bottomSection.image.url}
              fill
              sizes="100vw"
              style={{
                objectFit: 'cover',
              }}
            />
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={16} xl={16}>
          <div className={styles.panelSegmentContent}>
            <div className={styles.panelContent}>
              <PrismicRichText color="white" items={bottomSection.text} />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SafetyPageComponent;
